// Port de unpackJS : smoothpre embarque son jwplayer dans du JavaScript
// compressé par P.A.C.K.E.R. Chaque mot du dictionnaire y est remplacé par son
// index écrit dans la base donnée ; on fait le chemin inverse.

/** Capture les arguments de l'emballeur :
 *  eval(function(p,a,c,k,e,d){…}('<payload>', <base>, <count>, '<mots>'.split('|')… */
const PACKED_RE =
  /\}\s*\(\s*'([\s\S]*?)'\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*'([\s\S]*?)'\.split\('\|'\)/;

function isWordByte(c: string): boolean {
  return /[0-9a-zA-Z_]/.test(c);
}

/** Traduit un jeton en son mot du dictionnaire. L'emballeur écrit les index en
 *  minuscules : un jeton comportant une majuscule est un vrai identifiant du
 *  script, pas un index, et doit rester intact. */
function expandToken(
  token: string,
  base: number,
  count: number,
  words: string[],
): string {
  if (token !== token.toLowerCase()) return token;

  const n = Number.parseInt(token, base);

  if (!Number.isInteger(n) || n < 0 || n >= count || n >= words.length) return token;

  const word = words[n];

  return word === undefined || word === "" ? token : word;
}

/** Reconstitue le JavaScript compressé, ou "" si la page n'est pas compressée
 *  de cette façon. */
export function unpackJS(js: string): string {
  const match = PACKED_RE.exec(js);
  if (!match) return "";

  const base = Number(match[2]);
  const count = Number(match[3]);

  if (!Number.isInteger(base) || base < 2 || base > 36) return "";
  if (!Number.isInteger(count)) return "";

  const words = match[4]!.split("|");
  const payload = match[1]!;

  let out = "";

  for (let i = 0; i < payload.length; ) {
    if (!isWordByte(payload[i]!)) {
      out += payload[i];
      i++;
      continue;
    }

    let j = i;
    while (j < payload.length && isWordByte(payload[j]!)) j++;

    out += expandToken(payload.slice(i, j), base, count, words);
    i = j;
  }

  return out;
}
